import { FormFieldConfig, FormFieldType } from "../../interface";
import { ADMIN_INFERENCE_OPTIONS } from "./advanced-directive-settings.interface";

export const DNR_ONLY_INTUBATION_CONFIG: FormFieldConfig = {
  label: "",
  key: "dnrOnly_intubation",
  type: FormFieldType.Select,
  options: ADMIN_INFERENCE_OPTIONS,
};

export const DNI_ONLY_CPR_CONFIG: FormFieldConfig = {
  label: "",
  key: "dniOnly_cpr",
  type: FormFieldType.Select,
  options: ADMIN_INFERENCE_OPTIONS,
};

export const ERRORS = {
  GET: "Could not load Advanced Directive Settings. Please try again later.",
  SAVE: "Could not save Advanced Directive Settings. Please try again later.",
  SCHEDULE_NOT_READY: "Schedule data is not ready yet. Please try again in a moment.",
};

export const SUCCESS_MSG = "Settings saved.";
